import type { RadioCardOption } from '@/shared/ui/RadioCardGroup';

/**
 * Space visibility options - used for form validation and UI.
 *
 * `workspaces` is a form-only value with no wire counterpart: the API expresses "these specific
 * workspaces" as `spaceVisibility: 'workspace'` plus a `workspaceIds` list, and omitting the list
 * means the caller's own workspace. Keeping the two apart in the form is what lets the picker
 * appear for one option and not the other; `mapSpaceVisibility` collapses them on submit.
 */
// eslint-disable-next-line i18next/no-literal-string -- visibility scope wire enum values
export const spaceVisibilityValues = ['organization', 'workspace', 'workspaces'] as const;
export type SpaceVisibilityValue = (typeof spaceVisibilityValues)[number];

export interface VisibilityOption extends RadioCardOption<SpaceVisibilityValue> {
  checkedByDefault: boolean;
}
